import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { getIn } from 'seamless-immutable';

const ProductTitle = ({ asDesktop, currentSku, product }) => {
  const marginLeft = asDesktop ? 0 : 2;
  const skuLength = getIn(product, ['skus'], []).length;
  const title = skuLength > 1 && currentSku?.name ? getIn(currentSku, ['name'], '') : getIn(product, ['name'], '');

  return (
    <Title asDesktop={asDesktop} marginLeft={marginLeft}>
      {title}
    </Title>
  );
};

const Title = styled.h1`
  font-size: 16px;
  font-weight: bold;
  color: #666;
  text-transform: none;
  line-height: 1.1;
  margin-bottom: 5px;
  margin-left: ${({ marginLeft }) => marginLeft}px;
`;

ProductTitle.propTypes = {
  currentSku: PropTypes.object,
  product: PropTypes.object,
  asDesktop: PropTypes.bool,
};

export default ProductTitle;
